import { render, staticRenderFns } from "./MaterialInputItem.vue?vue&type=template&id=7a7c1a7d&scoped=true"
import script from "./MaterialInputItem.vue?vue&type=script&lang=ts"
export * from "./MaterialInputItem.vue?vue&type=script&lang=ts"
import style0 from "./MaterialInputItem.vue?vue&type=style&index=0&id=7a7c1a7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7c1a7d",
  null
  
)

export default component.exports